import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/ContentApproved";
import ApprovedDataset from "./ApprovedDataset";
import OtherDataset from "./OtherDataset";
import DatasetsNavbar from "../../components/DatasetsNavbar";
import { ToastProvider } from "react-toast-notifications";
import CustomToaster from "../../components/CustomToaster";

const index = ({ pageID, title }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const [visibleSidebar, setVisibleSidebar] = useState(true);

  const [DatsetCount, setDatsetCount] = useState(0);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [NavbarCollapse, setNavbarCollapse] = useState(true);
  const [dataFromChild, setDataFromChild] = useState(null);
  const [navTitle, setnavTitle] = useState("Datasets");

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };

  useEffect(() => {
    setnavTitle(title);
  }, [title]);

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  const handleCloseButtonClick = () => {
    setToggleBtn(false); // Set toggleBtn to false
  };

  return (
    <div className="top-wrapper datasetTopWrapper">
      <DatasetsNavbar
        setToggle={toggle}
        showDatasetCount={DatsetCount}
        navTitle={navTitle}
        type={pageID}
        NavbarCollapse={NavbarCollapse}
        onDataFromChild={handleDataFromChild}
      />
      <Sidebar
        toggleBtn={toggleBtn}
        onCloseButtonClick={handleCloseButtonClick}
      />

      <Content toggleBtn={toggleBtn}>
        {toasterVisible && (
          <CustomToaster
            message={toasterMessage}
            duration={3000}
            onClose={closeToaster}
            position="right-top"
            appearance={toasterAppearance}
          />
        )}
        {pageID === "data-sets" ? (
          <ApprovedDataset
            setDatsetCount={setDatsetCount}
            totalDatasets={DatsetCount}
            showToaster={showToaster}
            dataFromChild={dataFromChild}
            setnavTitle="Data Console"
          />
        ) : pageID === "other-datasets" ? (
          <OtherDataset
            setDatsetCount={setDatsetCount}
            showToaster={showToaster}
            dataFromChild={dataFromChild}
            setnavTitle="Data Sets"
          />
        ) : (
          { pageID }
        )}
      </Content>
    </div>
  );
};

export default index;
